/**
 * Created by Carsten Bühler
 * User: c.buehler on 09.06.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Table } from 'external/react-bootstrap';
import { translation } from 'plugin/liferay-widgets-react-web';

import DataSourcesTableItem from './DataSourcesTableItem';
import DataSourcesTableHeader from './DataSourcesTableHeader';


const DataSourcesTable = ({
                              dataList,
                              onClickEdit,
                              onClickDelete,
                              onClickMore,
                              ListHeader,
                              RowComponent,
                              defaultColspan
                          }) => {

    let colSpan = defaultColspan;

    let fillLevelRows = dataList && dataList.item && dataList.item.length > 0 ? dataList.item.map(
        dataSource => <RowComponent item={dataSource}
                                    onClickEdit={onClickEdit}
                                    onClickDelete={onClickDelete}
                                    key={dataSource.id}/>) : [];

    if (onClickEdit) {
        colSpan++;
    }

    if (onClickDelete) {
        colSpan++;
    }

    return (
        <React.Fragment>
            <Table responsive striped>
                <thead>
                <ListHeader/>
                </thead>
                <tbody>

                {fillLevelRows}

                {!dataList &&
                <tr key="-1">
                    <td colSpan={colSpan}>{translation.trans('no-entries')}</td>
                </tr>}

                {dataList && !dataList._loading && !dataList._more && !fillLevelRows.length > 0 &&
                <tr key="-2">
                    <td colSpan={colSpan}>{translation.trans('no-entries')}</td>
                </tr>}

                {dataList && !dataList._loading && dataList._more &&
                <tr key="-2">
                    <td onClick={onClickMore} colSpan={colSpan}>{translation.trans('load-more-results')}</td>
                </tr>}

                </tbody>
            </Table>
        </React.Fragment>
    );
};

DataSourcesTable.propTypes = {
    dataList: PropTypes.object,
    defaultColspan: PropTypes.number,
    ListHeader: PropTypes.func,
    RowComponent: PropTypes.func,
    onClickMore: PropTypes.func,
    onClickEdit: PropTypes.func,
    onClickDelete: PropTypes.func
};

DataSourcesTable.defaultProps = {
    defaultColspan: 4,
    ListHeader: DataSourcesTableHeader,
    RowComponent: DataSourcesTableItem
};


export default DataSourcesTable;




// WEBPACK FOOTER //
// ./js/components/DataSourcesTable.jsx